import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    user: null,
    room: null
  },
  mutations: {
    setUser (state,payload){
      state.user = payload.user
    },
    setRoom (state,payload) {
      state.room = payload.room
    },
  },
  actions: {
    init({dispatch}){
      dispatch('setSocketEvents')
    },
    setSocketEvents({state,rootState,dispatch,commit}){

      Vue.prototype.$socket.on('connect', () => {
      });

      Vue.prototype.$socket.on('disconnect', () => {
      });

      Vue.prototype.$socket.on('reconnect_attempt', () => {
        if(state.user.roomName){
          dispatch('joinRoom',{roomName: state.user.roomName, transcript: rootState.room.transcript, admin: state.room.data.admin, mode: state.room.data.mode, noEmit: true})
          Vue.prototype.$socket.emit('user update name', {name: state.user.name, noEmit: true})
        }
      });

      Vue.prototype.$socket.on('self update', function(message){
        commit('setUser',{user: message.user})
      });

      Vue.prototype.$socket.on('get room', function(message){
        Vue.prototype.$eventBus.$emit('socket: get room', message)
      });

      Vue.prototype.$socket.on('self room update', function(message){
        commit('setRoom', {room: message.room})
      });

      Vue.prototype.$socket.on('self join room', function(message){
        commit('setRoom', {room: message.room})
        Vue.prototype.$eventBus.$emit('socket: self join room', message)
        dispatch('extension/sendRoomEnter', {roomName: message.room.data.name}, {root:true})
      });

      Vue.prototype.$socket.on('user join room', function(message){
        Vue.prototype.$eventBus.$emit('socket: user join room', message)
      });

      Vue.prototype.$socket.on('new user message', function(message){
        Vue.prototype.$eventBus.$emit('socket: new user message', message)
        dispatch('apis/postCaptionZoom', {message: message}, {root:true})
      });

      Vue.prototype.$socket.on('user update name', function(message){
        Vue.prototype.$eventBus.$emit('socket: user update name', message)
      });

      Vue.prototype.$socket.on('user update mood', function(message){
        Vue.prototype.$eventBus.$emit('socket: user update mood', message)
      });

      Vue.prototype.$socket.on('user leave room', function(message){
        Vue.prototype.$eventBus.$emit('socket: user leave room', message)
      });

      Vue.prototype.$socket.on('self leave room', function(message){
        commit('setRoom', {room: null})
        Vue.prototype.$eventBus.$emit('socket: self leave room', message)
        dispatch('extension/sendRoomLeave', {}, {root:true})
      });

    },
    getRoom(_,payload) {
      Vue.prototype.$socket.emit('get room', payload.roomName)
    },
    joinRoom(state,payload) {
      let transcript = payload.transcript ? payload.transcript : []
      Vue.prototype.$socket.emit('user join room', {roomName: payload.roomName, transcript: transcript, demo: payload.roomName == 'DemoRoom', admin: payload.admin, mode: payload.mode, noEmit: payload.noEmit})
    },
    leaveRoom(_,payload) {
      Vue.prototype.$socket.emit('user leave room', payload.roomName)
    },
    setRoomMode(_,payload) {
      Vue.prototype.$socket.emit('set room mode', payload.mode)
    },
    clearRoom(_,payload) {
      Vue.prototype.$socket.emit('clear room', payload.roomName)
    },
  },
  getters: {
    isAdmin: (state) => {
      return state.room && state.room.data.admin == state.user.id
    },
    isDemo: (state) => {
      return state.room && state.room.data.demo
    },
  },
}
